<template lang="pug"> 
  n-dialog(
    v-model='dialog'
    max-width='600'
    :loading='loading'
  )
    v-card
      v-card-title.headline.blue.white--text(primary-title)
        | {{ $t('add-voucher-code') }}
      v-card-text.pt-5(flat)
        v-row
          v-col(cols='12')
            n-text-field-noemoji(
              v-model='form.code'
              hide-details
              :error-messages='codeError'
              :label="$t('label.voucher-code')"
              :placeholder="$t('placeholder.code')"
            )
      v-card-actions
        v-spacer
          v-btn(
            color="var(--bg-secondary-color)"
            class="white--text"
            depressed 
            @click='submit'
          ) {{ $t('button.add') }}
    dialog-promotion-lock(ref='dialogPromotionLockRef')

</template>
<script>
import { vouchers as apiVoucher } from '@/apis'
import DialogPromotionLock from '@/components/Promotion/DialogPromotionLock'

const DEFAULT = () => ({
    dialog: false,
    form : {},
    loading : false 

})
export default {
  components : {
    DialogPromotionLock,
  },
  data: () => DEFAULT(), 
  computed:{
    codeError () {
      return null
    }
  },
  methods : { 
    async open () {  
      this.reset()
      this.dialog = true
    }, 
    
    reset () {
      Object.assign(this.$data, DEFAULT())
    },

    close () {
      this.dialog = false
    },

    async submit () { 
      this.loading = true
      const [err,,messages,,status ] = await apiVoucher.redeem(this.form)
      this.loading = false
      
      if (status == 423) {
        this.$refs.dialogPromotionLockRef.open()
        return
      }

      if(err) { 
        this.$alert('',err,'warning')  
        return
      }    
 
      this.$alert('',messages,'success')  
      this.close()
    }, 
  }
}
</script>